module.exports = __webpack_public_path__ + "img/telenor.0b0c4cac.png";